import Modal from 'styled-react-modal'

const StyledCartModal = Modal.styled(({ theme }) => ({
  backgroundColor: theme.colors.grayscale.white,
  display: 'flex',
  height: '100%',
  flex: '1',
  marginLeft: 'auto',
  maxWidth: '582px',
  minHeight: '100%',
  padding: '0',
  position: 'relative',
  boxSizing: 'border-box',
}))

export default StyledCartModal
